import { Splide } from "@splidejs/splide";

document.addEventListener('alpine:init', () => {
    Alpine.data('imageSlider', () => ({

        splide: null,
        splideOptions: {
            type: "loop",
            drag: "free",
            perPage: 3,
            arrows: false,
            isNavigation: false,
            pagination: false,
        },
        dialogContent: "",

        init() {
            console.log(this.$refs.container);
            this.splide = new Splide(this.$refs.slider, this.splideOptions).mount();
            console.log(this.splide);
        },

        openModal($event) {
            this.dialogContent = $event.target.closest('.snap-teasers-horizontal--item').querySelector('template').innerHTML;
            this.$refs.dialog.showModal();
        },

        closeModal($event) {
            if ($event.target === this.$refs.dialog) {
                this.$refs.dialog.close();
            }
        },
    }));
});
